(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["friz-treggo"] && !Shopify.designMode) return;
  try {
    

(() => {
 const init = scope => scope.querySelectorAll('.tf').forEach(root => {
  if(root.dataset.ready) return;
  root.dataset.ready = '1';
  const main=root.querySelector('.tf-main'), zoom=root.querySelector('.tf-zoom-image'), dialog=root.querySelector('dialog');
  const thumbs=[...root.querySelectorAll('[data-image]')];
  const setImage=src=>{if(!main||!src)return;main.removeAttribute('srcset');main.src=src;if(zoom){zoom.removeAttribute('srcset');zoom.src=src;}thumbs.forEach(t=>t.setAttribute('aria-pressed',String(t.dataset.image===src)));};
  thumbs.forEach(t=>t.addEventListener('click',()=>setImage(t.dataset.image)));
  root.querySelector('[data-zoom]').addEventListener('click',()=>{if(zoom)dialog.showModal();});
  root.querySelector('[data-close]').addEventListener('click',()=>dialog.close());
  dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close();});
  const form=root.querySelector('.tf-form'), submit=root.querySelector('[data-submit]'), cart=root.querySelector('[data-cart-submit]'), select=root.querySelector('[data-variant]'), error=root.querySelector('[data-error-message]');
  let available=!submit.disabled,busy=false;
  if(select)select.addEventListener('change',()=>{const o=select.selectedOptions[0];available=o.dataset.available==='true';root.querySelector('[data-price]').textContent=o.dataset.price;root.querySelector('[data-sticky-price]').textContent=o.dataset.price;const compare=root.querySelector('[data-compare]');compare.textContent=o.dataset.compare||'';compare.hidden=!o.dataset.compare;submit.disabled=!available;cart.disabled=!available;submit.textContent=available?root.dataset.buy:root.dataset.sold;setImage(o.dataset.image);const url=new URL(location.href);url.searchParams.set('variant',o.value);history.replaceState({},'',url);});
  form.addEventListener('submit',async e=>{
   if(!window.fetch)return;
   e.preventDefault();if(busy||!available||!form.reportValidity())return;
   const toCart=e.submitter===cart;
   const data=new FormData(form);data.delete('return_to');
   busy=true;submit.disabled=true;cart.disabled=true;if(select)select.disabled=true;submit.textContent=root.dataset.pending;error.hidden=true;
   try{const response=await fetch(root.dataset.cartAdd+'.js',{method:'POST',body:data,headers:{'Accept':'application/json'}});const result=await response.json();if(!response.ok)throw new Error(result.description||root.dataset.error);const destination=new URL(root.dataset.cart,location.origin);if(!toCart)destination.searchParams.set('checkout','1');location.assign(destination.href);}
   catch(err){error.textContent=err.message||root.dataset.error;error.hidden=false;busy=false;submit.disabled=!available;cart.disabled=!available;if(select)select.disabled=false;submit.textContent=available?root.dataset.buy:root.dataset.sold;}
  });
 });
 init(document);document.addEventListener('shopify:section:load',e=>init(e.target));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["frizider-2109"] && !Shopify.designMode) return;
  try {
    
(function(){
function init(root){
 if(root.dataset.fp21Ready)return;root.dataset.fp21Ready='1';
 const picker=root.querySelector('[data-fp21-variant]'),qty=root.querySelector('[data-fp21-qty]');
 const base=root.querySelector('[data-fp21-checkout][href]');
 const cartBase=base?base.getAttribute('href').split('cart/')[0]+'cart/':window.Shopify.routes.root+'cart/';
 const defaultId=root.dataset.variant,defaultAvailable=root.dataset.available==='true';
 const price=root.querySelector('[data-fp21-price]'),sticky=root.querySelector('[data-fp21-sticky-price]');
 function showMedia(id){const media=[...root.querySelectorAll('[data-fp21-media]')];if(!media.some(m=>m.dataset.fp21Media===String(id)))return;media.forEach(m=>{m.hidden=m.dataset.fp21Media!==String(id);if(m.hidden)m.querySelectorAll('video').forEach(v=>v.pause());});root.querySelectorAll('[data-fp21-target]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.fp21Target===String(id))));}
 root.querySelectorAll('[data-fp21-target]').forEach(b=>b.addEventListener('click',()=>showMedia(b.dataset.fp21Target)));
 function option(){return picker?picker.options[picker.selectedIndex]:null;}
 function sale(){const o=option(),cents=o?Number(o.dataset.priceCents):Number(root.dataset.price),now=Date.now();const active=root.dataset.currency==='EUR'&&cents===19900&&now>=Date.parse(root.dataset.saleStart)&&now<Date.parse(root.dataset.saleEnd);root.querySelector('[data-fp21-campaign]').textContent=active?'SAMO DANAS · 21.09.':'TREGGO PONUDA';root.querySelector('[data-fp21-campaign-sub]').textContent=active?'21.09. · PONUDA DO PONOĆI':'UGOSTITELJSKI HLADNJAK';root.querySelector('[data-fp21-price-label]').textContent=active?'DANAS TVOJE ZA':'CIJENA PROIZVODA';root.querySelector('[data-fp21-offer-status]').hidden=!active;root.querySelector('[data-fp21-timer-wrap]').hidden=!active;root.querySelector('[data-fp21-corner]').hidden=!(cents===19900&&root.dataset.currency==='EUR');if(active){let n=Math.max(0,Math.floor((Date.parse(root.dataset.saleEnd)-now)/1000));root.querySelector('[data-fp21-timer]').textContent=[Math.floor(n/3600),Math.floor(n%3600/60),n%60].map(v=>String(v).padStart(2,'0')).join(':');}}
 function sync(){const o=option(),id=o?o.value:defaultId,available=o?o.dataset.available==='true':defaultAvailable;const count=Math.min(99,Math.max(1,Math.floor(Number(qty.value)||1)));qty.value=count;if(o){price.textContent=o.dataset.price;sticky.textContent=o.dataset.price;if(o.dataset.media)showMedia(o.dataset.media);const u=new URL(location.href);u.searchParams.set('variant',id);history.replaceState({},'',u);root.querySelector('[data-fp21-sku]').textContent=o.dataset.sku||'';root.querySelector('[data-fp21-sku-wrap]').hidden=!o.dataset.sku;}
 root.querySelectorAll('[data-fp21-checkout]').forEach(a=>{if(available){a.href=cartBase+id+':'+count;a.removeAttribute('aria-disabled');a.removeAttribute('tabindex');}else{a.removeAttribute('href');a.setAttribute('aria-disabled','true');a.setAttribute('tabindex','-1');}});root.querySelector('[data-fp21-buy-label]').textContent=available?'KUPI ODMAH':'TRENUTNO NEDOSTUPNO';const stock=root.querySelector('[data-fp21-availability]');stock.textContent=available?'● Dostupno za narudžbu':'● Trenutno nedostupno';stock.classList.toggle('is-out',!available);sale();}
 if(picker)picker.addEventListener('change',sync);qty.addEventListener('change',sync);root.querySelectorAll('[data-fp21-checkout]').forEach(a=>a.addEventListener('click',e=>{sync();if(a.getAttribute('aria-disabled')==='true')e.preventDefault();}));sync();const timer=setInterval(()=>{if(!root.isConnected)clearInterval(timer);else sale();},1000);
}
function boot(){document.querySelectorAll('[data-fp21-root]').forEach(init);}boot();document.addEventListener('shopify:section:load',boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["frizider-prodaja"] && !Shopify.designMode) return;
  try {
    
(function(){
function init(root){
 if(root.dataset.fpReady)return;root.dataset.fpReady='1';
 const picker=root.querySelector('[data-fp-variant]'),qty=root.querySelector('[data-fp-qty]');
 const base=root.querySelector('[data-fp-checkout][href]');
 const cartBase=base?base.getAttribute('href').split('cart/')[0]+'cart/':window.Shopify.routes.root+'cart/';
 const defaultId=root.dataset.variant,defaultAvailable=root.dataset.available==='true';
 const price=root.querySelector('[data-fp-price]'),sticky=root.querySelector('[data-fp-sticky-price]');
 function showMedia(id){const media=[...root.querySelectorAll('[data-fp-media]')];if(!media.some(m=>m.dataset.fpMedia===String(id)))return;media.forEach(m=>{m.hidden=m.dataset.fpMedia!==String(id);if(m.hidden)m.querySelectorAll('video').forEach(v=>v.pause());});root.querySelectorAll('[data-fp-target]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.fpTarget===String(id))));}
 root.querySelectorAll('[data-fp-target]').forEach(b=>b.addEventListener('click',()=>showMedia(b.dataset.fpTarget)));
 function option(){return picker?picker.options[picker.selectedIndex]:null;}
 function sale(){const o=option(),cents=o?Number(o.dataset.priceCents):Number(root.dataset.price),now=Date.now();const active=root.dataset.currency==='EUR'&&cents===19900&&now>=Date.parse(root.dataset.saleStart)&&now<Date.parse(root.dataset.saleEnd);root.querySelector('[data-fp-campaign]').textContent=active?'VIKEND AKCIJA':'TREGGO PONUDA';root.querySelector('[data-fp-campaign-sub]').textContent=active?'19. – 20. RUJNA · DO NEDJELJE U PONOĆ':'UGOSTITELJSKI HLADNJAK';root.querySelector('[data-fp-price-label]').textContent=active?'TVOJA VIKEND CIJENA':'CIJENA PROIZVODA';root.querySelector('[data-fp-offer-status]').hidden=!active;root.querySelector('[data-fp-timer-wrap]').hidden=!active;root.querySelector('[data-fp-corner]').hidden=!(cents===19900&&root.dataset.currency==='EUR');if(active){let n=Math.max(0,Math.floor((Date.parse(root.dataset.saleEnd)-now)/1000));root.querySelector('[data-fp-timer]').textContent=[Math.floor(n/3600),Math.floor(n%3600/60),n%60].map(v=>String(v).padStart(2,'0')).join(':');}}
 function sync(){const o=option(),id=o?o.value:defaultId,available=o?o.dataset.available==='true':defaultAvailable;const count=Math.min(99,Math.max(1,Math.floor(Number(qty.value)||1)));qty.value=count;if(o){price.textContent=o.dataset.price;sticky.textContent=o.dataset.price;if(o.dataset.media)showMedia(o.dataset.media);const u=new URL(location.href);u.searchParams.set('variant',id);history.replaceState({},'',u);root.querySelector('[data-fp-sku]').textContent=o.dataset.sku||'';root.querySelector('[data-fp-sku-wrap]').hidden=!o.dataset.sku;}
 root.querySelectorAll('[data-fp-checkout]').forEach(a=>{if(available){a.href=cartBase+id+':'+count;a.removeAttribute('aria-disabled');a.removeAttribute('tabindex');}else{a.removeAttribute('href');a.setAttribute('aria-disabled','true');a.setAttribute('tabindex','-1');}});root.querySelector('[data-fp-buy-label]').textContent=available?'KUPI ODMAH':'TRENUTNO NEDOSTUPNO';const stock=root.querySelector('[data-fp-availability]');stock.textContent=available?'● Dostupno za narudžbu':'● Trenutno nedostupno';stock.classList.toggle('is-out',!available);sale();}
 if(picker)picker.addEventListener('change',sync);qty.addEventListener('change',sync);root.querySelectorAll('[data-fp-checkout]').forEach(a=>a.addEventListener('click',e=>{sync();if(a.getAttribute('aria-disabled')==='true')e.preventDefault();}));sync();const timer=setInterval(()=>{if(!root.isConnected)clearInterval(timer);else sale();},1000);
}
function boot(){document.querySelectorAll('[data-fp-root]').forEach(init);}boot();document.addEventListener('shopify:section:load',boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pecenjara-prodaja"] && !Shopify.designMode) return;
  try {
    
(function(){
function init(root){
 if(root.dataset.ppReady)return;root.dataset.ppReady='1';
 const picker=root.querySelector('[data-pp-variant]'),qty=root.querySelector('[data-pp-qty]');
 const base=root.querySelector('[data-pp-checkout][href]');
 const cartBase=base?base.getAttribute('href').split('cart/')[0]+'cart/':window.Shopify.routes.root+'cart/';
 const defaultId=root.dataset.variant,defaultAvailable=root.dataset.available==='true';
 const price=root.querySelector('[data-pp-price]'),sticky=root.querySelector('[data-pp-sticky-price]');
 function showMedia(id){const media=[...root.querySelectorAll('[data-pp-media]')];if(!media.some(m=>m.dataset.ppMedia===String(id)))return;media.forEach(m=>{m.hidden=m.dataset.ppMedia!==String(id);if(m.hidden)m.querySelectorAll('video').forEach(v=>v.pause());});root.querySelectorAll('[data-pp-target]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.ppTarget===String(id))));}
 root.querySelectorAll('[data-pp-target]').forEach(b=>b.addEventListener('click',()=>showMedia(b.dataset.ppTarget)));
 function option(){return picker?picker.options[picker.selectedIndex]:null;}
 function sale(){const o=option(),cents=o?Number(o.dataset.priceCents):Number(root.dataset.price),now=Date.now();const active=root.dataset.currency==='EUR'&&cents===29900&&now>=Date.parse(root.dataset.saleStart)&&now<Date.parse(root.dataset.saleEnd);root.querySelector('[data-pp-campaign]').textContent=active?'VIKEND RASPRODAJA':'TREGGO PONUDA';root.querySelector('[data-pp-campaign-sub]').textContent=active?root.dataset.saleCaption:'PEČENJARA S RAŽNJEM I TEPSIJOM';root.querySelector('[data-pp-price-label]').textContent=active?'TVOJA VIKEND CIJENA':'CIJENA PROIZVODA';root.querySelector('[data-pp-offer-status]').hidden=!active;root.querySelector('[data-pp-timer-wrap]').hidden=!active;root.querySelector('[data-pp-corner]').hidden=!(cents===29900&&root.dataset.currency==='EUR');if(active){let n=Math.max(0,Math.floor((Date.parse(root.dataset.saleEnd)-now)/1000));root.querySelector('[data-pp-timer]').textContent=[Math.floor(n/3600),Math.floor(n%3600/60),n%60].map(v=>String(v).padStart(2,'0')).join(':');}}
 function sync(){const o=option(),id=o?o.value:defaultId,available=o?o.dataset.available==='true':defaultAvailable;const count=Math.min(99,Math.max(1,Math.floor(Number(qty.value)||1)));qty.value=count;if(o){price.textContent=o.dataset.price;sticky.textContent=o.dataset.price;if(o.dataset.media)showMedia(o.dataset.media);const u=new URL(location.href);u.searchParams.set('variant',id);history.replaceState({},'',u);root.querySelector('[data-pp-sku]').textContent=o.dataset.sku||'';root.querySelector('[data-pp-sku-wrap]').hidden=!o.dataset.sku;}
 root.querySelectorAll('[data-pp-checkout]').forEach(a=>{if(available){a.href=cartBase+id+':'+count;a.removeAttribute('aria-disabled');a.removeAttribute('tabindex');}else{a.removeAttribute('href');a.setAttribute('aria-disabled','true');a.setAttribute('tabindex','-1');}});root.querySelector('[data-pp-buy-label]').textContent=available?'KUPI ODMAH':'TRENUTNO NEDOSTUPNO';const stock=root.querySelector('[data-pp-availability]');stock.textContent=available?'● Dostupno za narudžbu':'● Trenutno nedostupno';stock.classList.toggle('is-out',!available);sale();}
 if(picker)picker.addEventListener('change',sync);qty.addEventListener('change',sync);root.querySelectorAll('[data-pp-checkout]').forEach(a=>a.addEventListener('click',e=>{sync();if(a.getAttribute('aria-disabled')==='true')e.preventDefault();}));sync();const timer=setInterval(()=>{if(!root.isConnected)clearInterval(timer);else sale();},1000);
}
function boot(){document.querySelectorAll('[data-pp-root]').forEach(init);}boot();document.addEventListener('shopify:section:load',boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["retro86-treggo"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('treggo-retro86')) {
  class TreggoRetro86 extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.variant = this.variants.find(v => String(v.id) === String(JSON.parse(this.querySelector('[data-initial]').textContent))) || this.variants.find(v => v.available) || this.variants[0];
      this.abort = new AbortController();
      this.addEventListener('click', event => this.onClick(event), { signal: this.abort.signal });
      window.addEventListener('popstate', () => {
        const id = new URL(location.href).searchParams.get('variant');
        const match = this.variants.find(v => String(v.id) === id);
        if (match) this.selectVariant(match, false, false);
      }, { signal: this.abort.signal });
      this.querySelectorAll('img').forEach(img => img.addEventListener('error', () => {
        if (img.classList.contains('r86-real-product')) {
          img.hidden = true;
          this.querySelector('[data-atlas]').hidden = false;
        }
      }, { signal: this.abort.signal }));
      if (this.variant) this.selectVariant(this.variant, false, false);
      const sticky = this.querySelector('[data-sticky]');
      const main = this.querySelector('.r86-main-buy');
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => { sticky.hidden = entries[0].isIntersecting; }, { threshold: 0.2 });
        this.observer.observe(main);
      }
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.ready = false;
    }
    onClick(event) {
      const variantButton = event.target.closest('[data-variant]');
      if (variantButton && this.contains(variantButton)) {
        event.preventDefault();
        const variant = this.variants.find(v => String(v.id) === variantButton.dataset.variant);
        if (variant?.available) this.selectVariant(variant, true, true);
        return;
      }
      const view = event.target.closest('[data-view]');
      if (view) { this.showPanel(view.dataset.view); return; }
      const buy = event.target.closest('[data-buy]');
      if (buy && (!this.variant?.available || buy.getAttribute('aria-disabled') === 'true')) event.preventDefault();
    }
    atlasPosition(color) {
      const value = String(color || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      if (/crven|red/.test(value)) return '50% 0%';
      if (/plav|blue/.test(value)) return '100% 0%';
      if (/bijel|white/.test(value)) return '0% 100%';
      if (/crn|black/.test(value)) return '50% 100%';
      if (/siv|srebr|grey|gray|silver/.test(value)) return '100% 100%';
      return '0% 0%';
    }
    showPanel(name) {
      this.querySelectorAll('[data-panel]').forEach(panel => { panel.hidden = panel.dataset.panel !== name; });
      this.querySelectorAll('[data-view]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.view === name)));
    }
    selectVariant(variant, updateHistory, announce) {
      this.variant = variant;
      this.querySelectorAll('[data-variant]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.variant === String(variant.id))));
      this.querySelectorAll('[data-price]').forEach(el => { el.innerHTML = variant.priceText; });
      this.querySelectorAll('[data-color-name]').forEach(el => { el.textContent = variant.title === 'Default Title' ? '' : variant.title; });
      this.querySelectorAll('[data-buy]').forEach(link => {
        if (variant.available) {
          link.href = this.dataset.cartUrl.replace(/\/$/, '') + '/' + variant.id + ':1';
          link.removeAttribute('aria-disabled');
          link.removeAttribute('tabindex');
        } else {
          link.removeAttribute('href');
          link.setAttribute('aria-disabled', 'true');
          link.setAttribute('tabindex', '-1');
        }
        link.querySelector('[data-buy-text]').textContent = variant.available ? this.dataset.buyLabel : this.dataset.unavailableLabel;
      });
      const atlas = this.querySelector('[data-atlas]');
      const real = this.querySelector('.r86-real-product');
      const position = this.atlasPosition(variant.color);
      atlas.style.backgroundPosition = position;
      atlas.setAttribute('aria-label', 'TREGGO RETRO 86 — ' + variant.title);
      this.querySelector('[data-mini-atlas]').style.backgroundPosition = position;
      if (variant.image) {
        real.removeAttribute('srcset');
        real.src = variant.image;
        real.alt = variant.title;
        real.hidden = false;
        atlas.hidden = true;
      } else if (this.variants.length > 1 || !real.getAttribute('src')) {
        real.hidden = true;
        atlas.hidden = false;
      }
      this.showPanel('product');
      if (updateHistory) {
        const url = new URL(location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      }
      if (announce) this.querySelector('[data-status]').textContent = variant.title + ' · ' + variant.priceText.replace(/<[^>]*>/g, '');
    }
  }
  customElements.define('treggo-retro86', TreggoRetro86);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["treggo-aqua49"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('treggo-aqua49')) {
  class TreggoAqua49 extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.addEventListener('click', event => {
        const thumb = event.target.closest('[data-image].aq49-thumb');
        if (thumb) {
          this.setImage(thumb.dataset.image, thumb.dataset.alt);
          this.querySelectorAll('.aq49-thumb').forEach(button => button.setAttribute('aria-pressed', String(button === thumb)));
        }
        const step = event.target.closest('[data-quantity-change]');
        if (step) {
          const input = this.querySelector('[name="quantity"]');
          const current = Number.parseInt(input.value, 10) || 1;
          input.value = String(Math.max(1, current + Number(step.dataset.quantityChange)));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }, { signal });
      const variantSelect = this.querySelector('[data-variant-select]');
      if (variantSelect) variantSelect.addEventListener('change', () => {
        const option = variantSelect.selectedOptions[0];
        this.querySelectorAll('[data-price]').forEach(node => {
          if (node.tagName !== 'OPTION') node.textContent = option.dataset.price;
        });
        const submit = this.querySelector('[data-submit]');
        const available = option.dataset.available === 'true';
        submit.disabled = !available;
        submit.textContent = available ? submit.dataset.buyLabel : submit.dataset.soldLabel;
        if (option.dataset.image) this.setImage(option.dataset.image);
        const url = new URL(window.location.href);
        if (url.protocol === 'http:' || url.protocol === 'https:') {
          url.searchParams.set('variant', option.value);
          window.history.replaceState({}, '', url);
        }
      }, { signal });
    }
    setImage(src, alt) {
      const image = this.querySelector('.aq49-main-image');
      if (!image || image.tagName !== 'IMG') return;
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = src;
      if (alt) image.alt = alt;
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.bound = false;
    }
  }
  customElements.define('treggo-aqua49', TreggoAqua49);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["treggo-domaci"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('treggo-domaci')) {
  customElements.define('treggo-domaci', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.controller = new AbortController();
      const listenerOptions = { signal: this.controller.signal };
      this.form = this.querySelector('.tgdom__form');
      this.select = this.querySelector('[data-variant]');
      this.quantity = this.querySelector('[name="quantity"]');
      this.buttons = [...this.querySelectorAll('[data-submit]')];
      this.error = this.querySelector('[data-error]');
      this.cartLink = this.querySelector('[data-cart-link]');
      this.mainImage = this.querySelector('.tgdom__main-image');
      this.dialog = this.querySelector('dialog');
      this.isBusy = false;
      this.thumbs = [...this.querySelectorAll('[data-thumb]')];
      this.activeImageIndex = 0;
      this.querySelector('[data-quantity-minus]').addEventListener('click', () => { this.quantity.stepDown(); this.quantity.dispatchEvent(new Event('change', { bubbles: true })); }, listenerOptions);
      this.querySelector('[data-quantity-plus]').addEventListener('click', () => { this.quantity.stepUp(); this.quantity.dispatchEvent(new Event('change', { bubbles: true })); }, listenerOptions);
      this.select.addEventListener('change', () => this.updateVariant(true), listenerOptions);
      this.quantity.addEventListener('change', () => this.updateTotal(), listenerOptions);
      this.quantity.addEventListener('input', () => this.updateTotal(), listenerOptions);
      this.querySelector('[data-gallery-prev]').addEventListener('click', () => this.moveImage(-1), listenerOptions);
      this.querySelector('[data-gallery-next]').addEventListener('click', () => this.moveImage(1), listenerOptions);
      let touchStart = null;
      this.mainImage.addEventListener('touchstart', event => { touchStart = event.touches[0] ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null; }, { ...listenerOptions, passive: true });
      this.mainImage.addEventListener('touchend', event => {
        if (!touchStart || !event.changedTouches[0]) return;
        const dx = event.changedTouches[0].clientX - touchStart.x;
        const dy = event.changedTouches[0].clientY - touchStart.y;
        if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.4) {
          this.moveImage(dx < 0 ? 1 : -1);
          this.suppressZoomUntil = Date.now() + 400;
        }
        touchStart = null;
      }, { ...listenerOptions, passive: true });
      this.querySelectorAll('[data-thumb]').forEach(button => button.addEventListener('click', () => {
        this.setImage(button.dataset.image, button.dataset.alt, button !== this.querySelector('[data-thumb]'));
        this.querySelectorAll('[data-thumb]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        this.querySelector('[data-caption-output]').textContent = button.dataset.caption;
        this.activeImageIndex = this.thumbs.indexOf(button);
        this.updateGalleryCount();
      }, listenerOptions));
      this.querySelector('[data-zoom]').addEventListener('click', () => {
        if (Date.now() < (this.suppressZoomUntil || 0)) return;
        const enlarged = this.dialog.querySelector('img');
        enlarged.src = this.mainImage.currentSrc || this.mainImage.src;
        enlarged.alt = this.mainImage.alt;
        this.dialog.showModal();
      }, listenerOptions);
      this.querySelector('[data-close]').addEventListener('click', () => this.dialog.close(), listenerOptions);
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); }, listenerOptions);
      this.form.addEventListener('submit', event => this.submitOrder(event), listenerOptions);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.querySelector('.tgdom__sticky').classList.toggle('is-main-visible', entries[0].isIntersecting);
        }, { threshold: 0.5 });
        this.observer.observe(this.form);
      }
      this.updateVariant(false);
      this.updateGalleryCount();
    }
    moveImage(direction) {
      if (!this.thumbs.length) return;
      const index = (this.activeImageIndex + direction + this.thumbs.length) % this.thumbs.length;
      this.thumbs[index].click();
      const rail = this.querySelector('.tgdom__thumbs');
      rail.scrollLeft = Math.max(0, this.thumbs[index].offsetLeft - rail.offsetLeft - 12);
    }
    updateGalleryCount() {
      this.querySelector('[data-gallery-count]').textContent = `${this.activeImageIndex + 1} / ${this.thumbs.length}`;
    }
    updateTotal() {
      const current = this.select.selectedOptions[0];
      const count = Number(this.quantity.value);
      const line = this.querySelector('[data-total-line]');
      line.hidden = !Number.isInteger(count) || count <= 1;
      if (!line.hidden) {
        const total = Number(current.dataset.cents || 0) * count / 100;
        this.querySelector('[data-total]').textContent = new Intl.NumberFormat(document.documentElement.lang || 'hr-HR', { style: 'currency', currency: this.dataset.currency || 'EUR' }).format(total);
      }
    }
    setImage(src, alt, contain) {
      if (!src) return;
      this.mainImage.removeAttribute('srcset');
      this.mainImage.removeAttribute('sizes');
      this.mainImage.src = src;
      this.mainImage.alt = alt || '';
      this.mainImage.classList.toggle('is-product', contain);
    }
    updateVariant(updateUrl) {
      const selected = this.select.selectedOptions[0];
      if (!selected) return;
      this.available = selected.dataset.available === 'true';
      this.querySelectorAll('[data-price]').forEach(price => { price.textContent = selected.dataset.price; });
      this.quantity.min = selected.dataset.min || '1';
      this.quantity.step = selected.dataset.step || '1';
      if (selected.dataset.max) this.quantity.max = selected.dataset.max;
      else this.quantity.removeAttribute('max');
      if (!this.quantity.validity.valid) this.quantity.value = this.quantity.min;
      this.setBusy(false);
      this.updateTotal();
      if (updateUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', selected.value);
        if (!(window.Shopify && window.Shopify.designMode)) history.replaceState({}, '', url);
        if (selected.dataset.image) {
          this.setImage(selected.dataset.image, selected.textContent, true);
          this.querySelectorAll('[data-thumb]').forEach(item => item.setAttribute('aria-pressed', 'false'));
          this.querySelector('[data-caption-output]').textContent = 'Prikaz odabrane izvedbe.';
          this.querySelector('[data-gallery-count]').textContent = 'Izvedba';
        }
      }
    }
    setBusy(busy) {
      this.isBusy = busy;
      this.buttons.forEach(button => {
        button.disabled = busy || !this.available;
        button.querySelector('[data-button-text]').textContent = busy ? this.dataset.labelLoading : (this.available ? this.dataset.labelBuy : this.dataset.labelSold);
      });
      this.form.setAttribute('aria-busy', String(busy));
      this.select.disabled = busy;
      this.quantity.disabled = busy;
      this.querySelectorAll('[data-quantity-minus], [data-quantity-plus]').forEach(button => { button.disabled = busy; });
    }
    async submitOrder(event) {
      event.preventDefault();
      if (this.isBusy || !this.available || !this.form.reportValidity()) return;
      const body = new FormData(this.form);
      body.delete('return_to');
      this.error.hidden = true;
      this.cartLink.hidden = true;
      this.setBusy(true);
      try {
        const response = await fetch(this.dataset.addUrl, { method: 'POST', headers: { 'Accept': 'application/json' }, body, credentials: 'same-origin' });
        const result = await response.json();
        if (!response.ok || result.status >= 400) {
          this.error.textContent = typeof result.description === 'string' ? result.description : 'Dodavanje nije uspjelo. Provjeri odabranu količinu i dostupnost.';
          this.error.hidden = false;
          this.setBusy(false);
          this.error.scrollIntoView({ block: 'center', behavior: 'auto' });
          return;
        }
        window.location.assign(this.dataset.checkoutUrl);
      } catch (error) {
        this.error.textContent = 'Nismo mogli potvrditi dodavanje. Prije ponovnog pokušaja provjeri svoju košaricu.';
        this.error.hidden = false;
        this.cartLink.hidden = false;
        this.setBusy(false);
        this.error.scrollIntoView({ block: 'center', behavior: 'auto' });
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.initialized = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["treggo-festa"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('treggo-festa')) {
  customElements.define('treggo-festa', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized) return;
      this.dataset.initialized = 'true';
      this.addEventListener('click', (event) => {
        const thumb = event.target.closest('[data-thumb]');
        if (thumb) {
          this.querySelectorAll('[data-slide]').forEach((slide) => { slide.hidden = slide.dataset.slide !== thumb.dataset.thumb; });
          this.querySelectorAll('[data-thumb]').forEach((button) => { button.setAttribute('aria-pressed', String(button === thumb)); });
        }
        const control = event.target.closest('[data-quantity]');
        if (control) {
          const quantity = this.querySelector('input[name="quantity"]');
          const minimum = Number(quantity.min) || 1;
          const step = Number(quantity.step) || 1;
          const maximum = quantity.max ? Number(quantity.max) : Infinity;
          quantity.value = Math.min(maximum, Math.max(minimum, (Number(quantity.value) || minimum) + Number(control.dataset.quantity) * step));
          quantity.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
      this.querySelector('[data-variant]')?.addEventListener('change', (event) => {
        const option = event.target.selectedOptions[0];
        const available = option.dataset.available === 'true';
        const submit = this.querySelector('[data-add]');
        submit.disabled = !available;
        submit.textContent = available ? this.dataset.addLabel : this.dataset.soldLabel;
        this.querySelectorAll('[data-price]').forEach((price) => { price.textContent = option.dataset.price; });
        const quantity = this.querySelector('input[name="quantity"]');
        quantity.min = option.dataset.min || '1';
        quantity.step = option.dataset.step || '1';
        if (option.dataset.max) quantity.max = option.dataset.max; else quantity.removeAttribute('max');
        quantity.value = quantity.min;
        const url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        window.history.replaceState({}, '', url);
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["treggo-fridge-199"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('treggo-fridge')) {
  customElements.define('treggo-fridge', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.abort = new AbortController();
      this.on = (node, event, callback) => node?.addEventListener(event, callback, { signal: this.abort.signal });
      this.form = this.querySelector('[data-tf-form]');
      this.qty = this.querySelector('[data-tf-quantity]');
      this.variantInput = this.form?.querySelector('[name="id"]');
      this.variants = JSON.parse(this.querySelector('[data-tf-variants]').textContent);
      this.strings = JSON.parse(this.querySelector('[data-tf-strings]').textContent);
      this.feedback = this.querySelector('[data-tf-feedback]');
      this.buttons = [...this.querySelectorAll('[data-tf-submit]')];
      this.checkoutTexts = [...this.querySelectorAll('[data-tf-button-text]')];
      this.checkoutTexts.forEach(label => { label.dataset.defaultLabel = label.textContent; });
      this.busy = false;
      this.on(this.querySelector('[data-tf-minus]'), 'click', () => { this.qty.stepDown(); this.normalizeQuantity(); });
      this.on(this.querySelector('[data-tf-plus]'), 'click', () => { this.qty.stepUp(); this.normalizeQuantity(); });
      this.on(this.qty, 'change', () => this.normalizeQuantity());
      this.on(this.qty, 'input', () => this.updateTotal());
      this.on(this.variantInput, 'change', () => this.updateVariant(true));
      this.on(this.form, 'submit', event => this.submit(event));
      this.updateVariant(false);
      this.observer = new IntersectionObserver(entries => { this.querySelector('[data-tf-sticky]').classList.toggle('is-visible', !entries[0].isIntersecting); }, { threshold: 0.15 });
      this.observer.observe(this.form);
      this.track = this.querySelector('.tf-gallery-track');
      const slideGallery = direction => this.track.scrollBy({ left: direction * (this.track.querySelector('button')?.getBoundingClientRect().width + 20 || 350), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      this.on(this.querySelector('[data-tf-gallery-prev]'), 'click', () => slideGallery(-1));
      this.on(this.querySelector('[data-tf-gallery-next]'), 'click', () => slideGallery(1));
      this.photos = [...this.querySelectorAll('[data-tf-photo]')];
      this.dialog = this.querySelector('[data-tf-dialog]');
      this.photos.forEach((button, index) => this.on(button, 'click', () => { this.lastPhotoButton = button; this.showPhoto(index); this.dialog.showModal(); }));
      this.on(this.querySelector('[data-tf-close]'), 'click', () => this.dialog.close());
      this.on(this.querySelector('[data-tf-prev]'), 'click', () => this.showPhoto(this.photoIndex - 1));
      this.on(this.querySelector('[data-tf-next]'), 'click', () => this.showPhoto(this.photoIndex + 1));
      this.on(this.dialog, 'click', event => { if (event.target === this.dialog) { const rect = this.dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close(); } });
      this.on(this.dialog, 'keydown', event => { if (event.key === 'ArrowRight') { event.preventDefault(); this.showPhoto(this.photoIndex + 1); } if (event.key === 'ArrowLeft') { event.preventDefault(); this.showPhoto(this.photoIndex - 1); } });
      this.on(this.dialog, 'close', () => this.lastPhotoButton?.focus({ preventScroll: true }));
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); this.initialized = false; }
    getVariant() { return this.variants.find(variant => String(variant.id) === this.variantInput.value) || this.variants[0]; }
    normalizeQuantity() {
      const min = Number(this.qty.min) || 1;
      const step = Number(this.qty.step) || 1;
      const max = this.qty.max ? Number(this.qty.max) : Infinity;
      const raw = Number(this.qty.value);
      const value = Math.min(max, Math.max(min, Number.isFinite(raw) ? raw : min));
      this.qty.value = String(min + Math.floor((value - min) / step) * step);
      this.updateTotal();
    }
    updateTotal() {
      const variant = this.getVariant();
      const count = Math.max(Number(this.qty.value) || 1, 1);
      const row = this.querySelector('[data-tf-total-row]');
      row.hidden = count === 1;
      this.querySelector('[data-tf-total]').textContent = new Intl.NumberFormat(this.dataset.locale || 'hr-HR', { style: 'currency', currency: this.dataset.currency || 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(variant.price * count / 100);
      this.querySelector('[data-tf-minus]').disabled = count <= Number(this.qty.min);
      this.querySelector('[data-tf-plus]').disabled = Boolean(this.qty.max) && count >= Number(this.qty.max);
    }
    updateVariant(changeUrl) {
      const variant = this.getVariant();
      if (!variant) return;
      const plain = new DOMParser().parseFromString(variant.formatted, 'text/html').body.textContent;
      this.querySelectorAll('[data-tf-price]').forEach(node => { node.textContent = plain; });
      this.buttons.forEach(button => { button.disabled = !variant.available || this.busy; });
      this.checkoutTexts.forEach(label => { label.textContent = variant.available ? label.dataset.defaultLabel : this.strings.soldOut; });
      this.qty.min = String(variant.min || 1);
      this.qty.step = String(variant.step || 1);
      if (variant.max) this.qty.max = String(variant.max); else this.qty.removeAttribute('max');
      this.querySelector('[data-tf-sku]').textContent = variant.sku || '';
      this.querySelector('[data-tf-sku-row]').hidden = !variant.sku;
      this.normalizeQuantity();
      if (changeUrl) { const url = new URL(location.href); url.searchParams.set('variant', String(variant.id)); history.replaceState({}, '', url); }
    }
    async submit(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (this.busy || !this.getVariant().available || !this.form.reportValidity()) return;
      this.normalizeQuantity();
      this.feedback.hidden = true;
      this.feedback.removeAttribute('data-error');
      if (document.documentElement.hasAttribute('data-tf-preview')) { this.feedback.textContent = this.strings.preview; this.feedback.hidden = false; return; }
      const destination = event.submitter?.dataset.destination === 'cart' ? this.dataset.cartUrl : this.dataset.checkoutUrl;
      this.busy = true;
      this.buttons.forEach(button => { button.disabled = true; });
      this.form.setAttribute('aria-busy', 'true');
      this.checkoutTexts.forEach(label => { label.textContent = this.strings.busy; });
      try {
        const formData = new FormData(this.form);
        const response = await fetch(this.dataset.addUrl, { method: 'POST', headers: { Accept: 'application/json' }, credentials: 'same-origin', body: formData });
        const result = await response.json();
        if (!response.ok || result.status >= 400) throw new Error(typeof result.description === 'string' ? result.description : this.strings.error);
        location.assign(destination);
      } catch (error) {
        this.feedback.textContent = error instanceof TypeError ? this.strings.error : (error.message || this.strings.error);
        this.feedback.hidden = false;
        this.feedback.setAttribute('data-error', '');
        this.feedback.tabIndex = -1;
        this.feedback.scrollIntoView({ block: 'center', behavior: 'instant' });
        this.feedback.focus({ preventScroll: true });
        this.busy = false;
        this.form.removeAttribute('aria-busy');
        this.updateVariant(false);
      }
    }
    showPhoto(index) {
      if (!this.photos.length) return;
      this.photoIndex = (index + this.photos.length) % this.photos.length;
      const photo = this.photos[this.photoIndex];
      const img = this.querySelector('[data-tf-dialog-image]');
      img.src = photo.dataset.full;
      img.alt = photo.querySelector('img').alt;
      this.querySelector('[data-tf-counter]').textContent = `${this.photoIndex + 1} / ${this.photos.length}`;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["treggo-gazda-mini"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('treggo-gazda-mini')) {
  customElements.define('treggo-gazda-mini', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.sticky = this.querySelector('[data-sticky]');
      if (this.sticky) document.body.appendChild(this.sticky);
      this.querySelectorAll('[data-image]').forEach(button => button.addEventListener('click', () => {
        const main = this.querySelector('.gm__main-image');
        if (!main) return;
        main.removeAttribute('srcset');
        main.src = button.dataset.image;
        main.alt = button.dataset.alt;
        this.querySelectorAll('[data-image]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      }, {signal}));
      const select = this.querySelector('[data-variant]');
      if (select) select.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        const available = option.dataset.available === 'true';
        const roots = [this, this.sticky].filter(Boolean);
        roots.forEach(root => {
          root.querySelectorAll('[data-price]').forEach(el => el.textContent = option.dataset.price);
          root.querySelectorAll('[data-purchase]').forEach(button => {
            button.disabled = !available;
            button.replaceChildren(document.createTextNode(available ? this.dataset.cta : this.dataset.unavailable));
            const arrow = document.createElement('span');
            arrow.textContent = '↗';
            arrow.setAttribute('aria-hidden', 'true');
            button.appendChild(arrow);
          });
        });
        const url = new URL(window.location.href);
        url.searchParams.set('variant', select.value);
        history.replaceState({}, '', url);
      }, {signal});
    }
    disconnectedCallback() {
      if (this.abort) this.abort.abort();
      if (this.sticky) this.sticky.remove();
      this.initialized = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["treggo-gazda-stol"] && !Shopify.designMode) return;
  try {
    

(function(){
function setup(root){if(root.dataset.ready)return;root.dataset.ready='true';
root.querySelectorAll('[data-image]').forEach(function(button){button.addEventListener('click',function(){root.querySelector('[data-main]').src=button.dataset.image;root.querySelectorAll('[data-image]').forEach(function(b){b.setAttribute('aria-pressed',String(b===button));});});});
var selector=root.querySelector('[data-variant]');if(selector){selector.addEventListener('change',function(){var option=selector.options[selector.selectedIndex];var available=option.dataset.available==='true';root.querySelectorAll('[data-price]').forEach(function(el){el.textContent=option.dataset.price;});root.querySelectorAll('[data-buy-button]').forEach(function(b){b.disabled=!available;b.textContent=available?root.dataset.buy:root.dataset.sold;});var u=new URL(window.location.href);u.searchParams.set('variant',option.value);history.replaceState({},'',u);});}
}
document.querySelectorAll('[data-gazda]').forEach(setup);document.addEventListener('shopify:section:load',function(e){e.target.querySelectorAll('[data-gazda]').forEach(setup);});
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["treggo-mirvo-one"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('treggo-mirvo-product')) {
  customElements.define('treggo-mirvo-product', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.form = this.querySelector('[data-tmo-form]');
      this.variants = JSON.parse(this.querySelector('[data-tmo-variants]')?.textContent || '[]');
      this.status = this.querySelector('[data-tmo-status]');
      this.addEventListener('submit', event => this.submitOrder(event), { signal });
      this.addEventListener('change', event => {
        if (event.target.matches('[data-tmo-variant]')) this.updateVariant(true);
      }, { signal });
      this.addEventListener('click', event => {
        const step = event.target.closest('[data-tmo-step]');
        if (step && this.form && !this.busy) {
          const input = this.form.querySelector('[name="quantity"]');
          if (Number(step.dataset.tmoStep) > 0) input.stepUp(); else input.stepDown();
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        const thumb = event.target.closest('[data-tmo-photo]');
        if (thumb) this.setPhoto(thumb.dataset.tmoPhoto, thumb.dataset.tmoAlt, thumb);
      }, { signal });
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.classList.toggle('is-hero-visible', entries[0].isIntersecting);
        }, { threshold: 0.15 });
        const buy = this.querySelector('.tmo__buy');
        if (buy) this.observer.observe(buy);
      }
      window.addEventListener('pageshow', event => {
        if (event.persisted) { this.setBusy(false); this.updateVariant(false); }
      }, { signal });
      this.updateVariant(false);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
    }
    selectedVariant() {
      const id = this.form?.querySelector('[name="id"]')?.value;
      return this.variants.find(variant => String(variant.id) === String(id));
    }
    formatMoney(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'hr-HR', { style: 'currency', currency: this.dataset.currency || 'EUR' }).format(cents / 100);
    }
    setPhoto(src, alt, active) {
      const image = this.querySelector('.tmo__hero-phone');
      if (!image) return;
      image.removeAttribute('srcset');
      image.src = src;
      if (alt) image.alt = alt;
      this.querySelectorAll('[data-tmo-photo]').forEach(button => button.setAttribute('aria-pressed', String(button === active)));
    }
    updateVariant(updateUrl) {
      if (!this.form) return;
      const variant = this.selectedVariant();
      if (!variant) return;
      this.querySelectorAll('[data-tmo-price]').forEach(node => { node.textContent = this.formatMoney(variant.price); });
      const comparison = this.querySelector('[data-tmo-compare]');
      if (comparison) {
        comparison.hidden = !(variant.compare_at_price > variant.price);
        comparison.textContent = this.formatMoney(variant.compare_at_price || 0);
      }
      this.querySelectorAll('[data-tmo-action]').forEach(button => {
        button.disabled = !variant.available || !!this.busy;
        button.querySelector('span').textContent = variant.available ? (button.dataset.tmoAction === 'cart' ? this.dataset.addLabel : this.dataset.buyLabel) : this.dataset.soldLabel;
      });
      const quantity = this.form.querySelector('[name="quantity"]');
      const rule = variant.quantity_rule || {};
      quantity.min = rule.min || 1;
      quantity.step = rule.increment || 1;
      if (rule.max) quantity.max = rule.max; else quantity.removeAttribute('max');
      const min = Number(quantity.min), step = Number(quantity.step);
      let value = Math.max(min, Number(quantity.value) || min);
      value = min + Math.floor((value - min) / step) * step;
      if (rule.max) value = Math.min(value, min + Math.floor((rule.max - min) / step) * step);
      quantity.value = value;
      if (updateUrl) {
        if (variant.featured_image?.src) this.setPhoto(variant.featured_image.src, variant.featured_image.alt);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    }
    setBusy(busy) {
      this.busy = busy;
      this.querySelectorAll('[data-tmo-action]').forEach(button => button.setAttribute('aria-busy', String(busy)));
      this.form?.querySelectorAll('select, [name="quantity"], [data-tmo-step]').forEach(control => { control.disabled = busy; });
      this.updateVariant(false);
    }
    async submitOrder(event) {
      if (event.target !== this.form) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (this.busy) return;
      const variant = this.selectedVariant();
      if (!variant?.available || !this.form.reportValidity()) return;
      const destination = event.submitter?.dataset.tmoAction === 'cart' ? this.dataset.cartUrl : this.dataset.checkoutUrl;
      const data = new FormData(this.form);
      data.delete('return_to');
      this.status.classList.remove('is-error');
      this.status.textContent = this.dataset.busyLabel;
      this.setBusy(true);
      try {
        const response = await fetch(this.dataset.addUrl, { method: 'POST', headers: { Accept: 'application/json' }, body: data, credentials: 'same-origin' });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || this.dataset.errorLabel);
        this.status.textContent = this.dataset.addedLabel;
        window.location.assign(destination);
      } catch (error) {
        this.status.textContent = error.message && !(error instanceof SyntaxError) && !(error instanceof TypeError) ? error.message : this.dataset.errorLabel;
        this.status.classList.add('is-error');
        this.setBusy(false);
        this.status.focus({ preventScroll: false });
      }
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["treggo-motor-75"] && !Shopify.designMode) return;
  try {
    

(() => {
  const setup = root => {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    const form = root.querySelector('form');
    if (!form) return;
    const quantity = form.elements.quantity;
    const variantInput = form.elements.id;
    const variants = JSON.parse(root.querySelector('[data-variants]').textContent);
    const allButtons = [...root.querySelectorAll('[data-buy-button], [data-cart-button]')];
    let busy = false;
    const current = () => variants.find(v => String(v.id) === variantInput.value);
    const error = text => root.querySelectorAll('[data-error-message]').forEach(node => node.textContent = text);
    const syncButtons = () => {
      const available = !!current()?.available;
      allButtons.forEach(button => {button.disabled = busy || !available;});
      root.querySelectorAll('[data-button-label]').forEach(node => node.textContent = busy ? root.dataset.busy : available ? root.dataset.buy : root.dataset.sold);
      form.setAttribute('aria-busy', String(busy));
    };
    const normaliseQty = () => {
      const min = Number(quantity.min) || 1;
      const step = Number(quantity.step) || 1;
      const max = quantity.max ? Number(quantity.max) : Infinity;
      const value = Number(quantity.value);
      let adjusted = Number.isFinite(value) ? Math.max(min, min + Math.floor((value - min) / step) * step) : min;
      if (max < Infinity) adjusted = Math.min(adjusted, min + Math.floor((max - min) / step) * step);
      quantity.value = String(adjusted);
      root.querySelector('[data-minus]').disabled = adjusted <= min;
      root.querySelector('[data-plus]').disabled = adjusted + step > max;
    };
    root.querySelector('[data-minus]').addEventListener('click', () => { quantity.stepDown(); normaliseQty(); });
    root.querySelector('[data-plus]').addEventListener('click', () => { quantity.stepUp(); normaliseQty(); });
    quantity.addEventListener('change', normaliseQty);
    const setImage = (url, alt) => {
      const img = root.querySelector('.tm75-main-image');
      if (!img || !url) return;
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = url;
      if (alt) img.alt = alt;
    };
    root.querySelectorAll('.tm75-thumb').forEach(button => button.addEventListener('click', () => {
      setImage(button.dataset.image, button.dataset.alt);
      root.querySelectorAll('.tm75-thumb').forEach(other => other.setAttribute('aria-pressed', String(other === button)));
    }));
    variantInput.addEventListener('change', () => {
      const variant = current();
      if (!variant) return;
      root.querySelectorAll('[data-price]').forEach(node => node.textContent = variant.price);
      quantity.min = String(variant.min || 1);
      quantity.step = String(variant.step || 1);
      quantity.max = variant.max == null ? '' : String(variant.max);
      normaliseQty();
      if (variant.image) setImage(variant.image);
      const url = new URL(location.href);
      url.searchParams.set('variant', String(variant.id));
      history.replaceState({}, '', url);
      error('');
      syncButtons();
    });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy || !current()?.available) return;
      normaliseQty();
      if (!form.reportValidity()) return;
      error('');
      if (root.dataset.preview === 'true') { error(`${root.dataset.previewLabel}: ${quantity.value}.`); return; }
      busy = true;
      syncButtons();
      try {
        const response = await fetch(root.dataset.addUrl, {method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({items:[{id:Number(variantInput.value), quantity:Number(quantity.value)}]})});
        const data = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : root.dataset.error);
        location.assign(event.submitter?.hasAttribute('data-cart-button') ? root.dataset.cartUrl : root.dataset.checkoutUrl);
      } catch (failure) {
        error(failure.message || root.dataset.error);
        busy = false;
        syncButtons();
      }
    });
    normaliseQty();
    syncButtons();
  };
  const init = () => document.querySelectorAll('[data-tm75]').forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
  document.addEventListener('shopify:section:load', init);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["treggo-paviljon"] && !Shopify.designMode) return;
  try {
    
(() => {
 const init = (scope) => {
  scope.querySelectorAll('.tg-pavilion').forEach((root) => {
  if (!root || root.dataset.ready === '1') return;
  root.dataset.ready = '1';

  const main = root.querySelector('.tg-main-image');
  const thumbs = root.querySelectorAll('.tg-thumb');
  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      if (main && thumb.dataset.tgImage) { main.removeAttribute('srcset'); main.src = thumb.dataset.tgImage; }
      thumbs.forEach((t) => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });

  const select = root.querySelector('[data-tg-variant]');
  const price = root.querySelector('[data-tg-price]');
  const stickyPrice = root.querySelector('[data-tg-sticky-price]');
  const submit = root.querySelector('[data-tg-submit]');

  if (select) {
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const newPrice = option.dataset.price;
      const compare = root.querySelector('[data-tg-compare]');
      compare.textContent = option.dataset.compare || '';
      compare.hidden = !option.dataset.compare;
      if (main && option.dataset.image) { main.removeAttribute('srcset'); main.src = option.dataset.image; }
      const available = option.dataset.available === 'true';

      if (price && newPrice) price.textContent = newPrice;
      if (stickyPrice && newPrice) stickyPrice.textContent = newPrice;

      if (submit) {
        submit.disabled = !available;
        submit.textContent = available ? 'DODAJ U KOŠARICU' : 'TRENUTNO NEDOSTUPNO';
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      history.replaceState({}, '', url.toString());
    });
  }
  });
 };
 init(document);
 document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["treggo-peka"] && !Shopify.designMode) return;
  try {
    
(()=>{function init(scope){scope.querySelectorAll('.tp-page:not([data-ready])').forEach(root=>{root.dataset.ready='true';const form=root.querySelector('.tp-form'),qty=root.querySelector('input[name="quantity"]'),selector=root.querySelector('[name="id"]'),buttons=root.querySelectorAll('[data-buy-button]');if(!form||!qty||!selector)return;let variants=[];try{variants=JSON.parse(root.dataset.variants||'[]')}catch(e){}const format=v=>new Intl.NumberFormat('hr-HR',{style:'currency',currency:'EUR',minimumFractionDigits:v%100?2:0,maximumFractionDigits:2}).format(v/100);const normalizedQty=()=>{let q=Number(qty.value);if(!Number.isFinite(q)||q<1)q=1;q=Math.floor(q);qty.value=String(q);return q};function update(){const q=normalizedQty(),v=variants.find(x=>String(x.id)===String(selector.value));if(!v)return;root.querySelectorAll('[data-unit-price]').forEach(el=>el.textContent=format(v.price));root.querySelectorAll('[data-total-price],[data-sticky-price]').forEach(el=>el.textContent=format(v.price*q));root.querySelector('.tp-subtotal').hidden=q===1;buttons.forEach(b=>{b.disabled=!v.available;b.querySelector('[data-buy-label]').textContent=v.available?root.dataset.buy:root.dataset.unavailable});}root.querySelectorAll('[data-qty]').forEach(b=>b.addEventListener('click',()=>{qty.value=String(Math.max(1,normalizedQty()+Number(b.dataset.qty)));update()}));qty.addEventListener('change',update);selector.addEventListener('change',update);root.querySelectorAll('.tp-thumb').forEach(b=>b.addEventListener('click',()=>{const img=root.querySelector('.tp-hero-photo>img');img.src=b.dataset.src;img.removeAttribute('srcset');img.alt=b.dataset.alt;root.querySelectorAll('.tp-thumb').forEach(el=>el.setAttribute('aria-pressed',String(el===b)))}));const dialog=root.querySelector('.tp-lightbox');root.querySelector('[data-zoom]').addEventListener('click',()=>{const main=root.querySelector('.tp-hero-photo>img'),img=dialog.querySelector('img');img.src=main.currentSrc||main.src;img.alt=main.alt;if(typeof dialog.showModal==='function')dialog.showModal()});dialog.querySelector('.tp-close').addEventListener('click',()=>dialog.close());dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close()});form.addEventListener('submit',e=>{const v=variants.find(x=>String(x.id)===String(selector.value));normalizedQty();if(!v||!v.available){e.preventDefault();return}if(root.hasAttribute('data-preview')){e.preventDefault();document.getElementById('preview-notice').showModal()}});update()})}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document));else init(document);document.addEventListener('shopify:section:load',event=>init(event.target))})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["treggo-solar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('treggo-solar-product')) {
    customElements.define('treggo-solar-product', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.addEventListener('click', (event) => {
          const thumb = event.target.closest('[data-tgsolar-thumb]');
          if (thumb && this.contains(thumb)) {
            event.preventDefault();
            this.selectImage(thumb.dataset.tgsolarThumb);
          }
          const step = event.target.closest('[data-tgsolar-step]');
          if (step && this.contains(step)) {
            const input = this.querySelector('[data-tgsolar-quantity]');
            if (!input) return;
            const value = Number.parseInt(input.value, 10);
            input.value = Math.max(1, (Number.isFinite(value) ? value : 1) + Number(step.dataset.tgsolarStep));
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
        const select = this.querySelector('[data-tgsolar-variant]');
        if (select) select.addEventListener('change', () => {
          const option = select.selectedOptions[0];
          if (!option) return;
          this.querySelectorAll('[data-tgsolar-price]').forEach((price) => { price.textContent = option.dataset.price; });
          const available = option.dataset.available === 'true';
          this.querySelectorAll('[data-tgsolar-add]').forEach((button) => { button.disabled = !available; });
          this.querySelectorAll('[data-tgsolar-add-text]').forEach((label) => { label.textContent = available ? this.dataset.addLabel : this.dataset.soldLabel; });
          if (option.dataset.image) this.selectImage(option.dataset.image);
          const url = new URL(window.location.href);
          url.searchParams.set('variant', option.value);
          window.history.replaceState({}, '', url.toString());
        });
      }
      selectImage(id) {
        if (!this.querySelector('[data-tgsolar-slide="' + id + '"]')) return;
        this.querySelectorAll('[data-tgsolar-slide]').forEach((slide) => { slide.hidden = slide.dataset.tgsolarSlide !== id; });
        this.querySelectorAll('[data-tgsolar-thumb]').forEach((thumb) => {
          const selected = thumb.dataset.tgsolarThumb === id;
          thumb.classList.toggle('is-selected', selected);
          if (selected) thumb.setAttribute('aria-current', 'true');
          else thumb.removeAttribute('aria-current');
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["treggo-voda"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('treggo-water')) {
  class TreggoWater extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.addEventListener('click', event => {
        const thumb = event.target.closest('[data-image].tw-thumb');
        if (thumb) {
          this.setImage(thumb.dataset.image, thumb.dataset.alt);
          this.querySelectorAll('.tw-thumb').forEach(button => button.setAttribute('aria-pressed', String(button === thumb)));
        }
        const step = event.target.closest('[data-quantity-change]');
        if (step) {
          const input = this.querySelector('[name="quantity"]');
          const current = Number.parseInt(input.value, 10) || 1;
          input.value = String(Math.max(1, current + Number(step.dataset.quantityChange)));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }, { signal });
      const variantSelect = this.querySelector('[data-variant-select]');
      if (variantSelect) variantSelect.addEventListener('change', () => {
        const option = variantSelect.selectedOptions[0];
        this.querySelectorAll('[data-price]').forEach(node => {
          if (node.tagName !== 'OPTION') node.textContent = option.dataset.price;
        });
        const submit = this.querySelector('[data-submit]');
        const available = option.dataset.available === 'true';
        submit.disabled = !available;
        submit.textContent = available ? submit.dataset.buyLabel : submit.dataset.soldLabel;
        if (option.dataset.image) this.setImage(option.dataset.image);
        const url = new URL(window.location.href);
        if (url.protocol === 'http:' || url.protocol === 'https:') {
          url.searchParams.set('variant', option.value);
          window.history.replaceState({}, '', url);
        }
      }, { signal });
    }
    setImage(src, alt) {
      const image = this.querySelector('.tw-main-image');
      if (!image || image.tagName !== 'IMG') return;
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = src;
      if (alt) image.alt = alt;
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.bound = false;
    }
  }
  customElements.define('treggo-water', TreggoWater);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trg-mirvo-nova"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = scope => {
    const roots = scope.matches?.('[data-mnv-section]') ? [scope] : scope.querySelectorAll('[data-mnv-section]');
    roots.forEach(root => {
      if (root.dataset.mnvReady === 'true') return;
      root.dataset.mnvReady = 'true';
      const form = root.querySelector('[data-mnv-form]');
      if (!form) return;
      const variants = JSON.parse(root.querySelector('[data-mnv-variants]')?.textContent || '[]');
      const quantity = form.querySelector('[name="quantity"]');
      const status = root.querySelector('[data-mnv-status]');
      const current = () => variants.find(item => String(item.id) === form.elements.namedItem('id').value);
      const money = cents => new Intl.NumberFormat('hr-HR', { style: 'currency', currency: root.dataset.currency || 'EUR' }).format(cents / 100);
      const image = root.querySelector('.mnv__hero-phone');
      const selectImage = (src, alt, active) => {
        if (!image) return;
        image.removeAttribute('srcset');
        image.src = src;
        if (alt) image.alt = alt;
        root.querySelectorAll('[data-mnv-photo]').forEach(button => button.setAttribute('aria-pressed', String(button === active)));
      };
      const update = changeUrl => {
        const variant = current();
        if (!variant) return;
        root.querySelectorAll('[data-mnv-price]').forEach(node => { node.textContent = money(variant.price); });
        root.querySelectorAll('[data-mnv-action]').forEach(button => {
          button.disabled = !variant.available;
          button.querySelector('span').textContent = variant.available ? (button.dataset.mnvAction === 'cart' ? root.dataset.addLabel : root.dataset.buyLabel) : root.dataset.soldLabel;
        });
        const compare = root.querySelector('[data-mnv-compare]');
        if (compare) { compare.hidden = !(variant.compare_at_price > variant.price); compare.textContent = money(variant.compare_at_price || 0); }
        const rule = variant.quantity_rule || {};
        const min = Number(rule.min) || 1, step = Number(rule.increment) || 1;
        quantity.min = min;
        quantity.step = step;
        if (rule.max) quantity.max = rule.max; else quantity.removeAttribute('max');
        let value = min + Math.max(0, Math.floor(((Number(quantity.value) || min) - min) / step)) * step;
        if (rule.max) value = Math.min(value, min + Math.floor((rule.max - min) / step) * step);
        quantity.value = value;
        if (changeUrl) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);
          if (variant.featured_image?.src) selectImage(variant.featured_image.src, variant.featured_image.alt);
        }
      };
      const reset = () => {
        delete root.dataset.mnvSubmitting;
        root.classList.remove('mnv--submitting');
        root.querySelectorAll('[data-mnv-action]').forEach(button => button.removeAttribute('aria-busy'));
        status.textContent = '';
      };
      root.addEventListener('click', event => {
        const step = event.target.closest('[data-mnv-step]');
        if (step) {
          event.preventDefault();
          event.stopPropagation();
          if (Number(step.dataset.mnvStep) > 0) quantity.stepUp(); else quantity.stepDown();
          quantity.dispatchEvent(new Event('change', { bubbles: true }));
        }
        const thumb = event.target.closest('[data-mnv-photo]');
        if (thumb) selectImage(thumb.dataset.mnvPhoto, thumb.dataset.mnvAlt, thumb);
      });
      root.addEventListener('change', event => {
        if (event.target.matches('[data-mnv-variant]')) { reset(); update(true); }
      });
      root.addEventListener('submit', event => {
        if (event.target !== form) return;
        event.stopPropagation();
        if (root.dataset.mnvSubmitting === 'true' || !current()?.available || !form.reportValidity()) {
          event.preventDefault();
          return;
        }
        root.dataset.mnvSubmitting = 'true';
        root.classList.add('mnv--submitting');
        root.querySelectorAll('[data-mnv-action]').forEach(button => button.setAttribute('aria-busy', 'true'));
        status.textContent = root.dataset.busyLabel;
      }, true);
      window.addEventListener('pageshow', reset);
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => root.classList.toggle('is-hero-visible', entries[0].isIntersecting), { threshold: 0.15 });
        const button = root.querySelector('.mnv__buy');
        if (button) observer.observe(button);
        document.addEventListener('shopify:section:unload', event => { if (event.target.contains(root)) observer.disconnect(); });
      }
      update(false);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();


  } catch(e) { console.error(e); }
})();
})();
